export enum NavLinksSemantics {
  Home = 'home',
  Support = 'support',
  Arcade = 'arcade',
  Servers = 'servers',
  Discord = 'discord',
  Events = 'events',
  Tournaments = 'tournaments',
  Challenges = 'challenges',
  Watch = 'watch',
  Store = 'store',
  Blog = 'blog',
}
